export default function PricingFeatures({items}) {
    return (
        <div className="generic_feature_list">
            <ul>
                {items && items.map((item, index) => <li key={index}>{item}</li>)}
                {/* <li><span>2GB</span> Bandwidth</li> */}
            </ul>
        </div>
    );
}